import { Component, EventEmitter, Input, Output } from '@angular/core';

import { ReopenRequestViewModel } from 'app/request-form/_models/reopen-request.view-model';

@Component({
  selector: 'app-reopen-request',
  templateUrl: './reopen-request.component.html',
  styleUrls: ['./reopen-request.component.scss'],
  standalone: false,
})
export class ReopenRequestComponent {
  @Input() viewModel: ReopenRequestViewModel;

  @Output() submissionClick = new EventEmitter<any>();
  @Output() cancelClick = new EventEmitter<any>();

  onClickSubmit() {
    this.submissionClick.emit();
  }

  onClickCancel() {
    this.cancelClick.emit();
  }
}
